import { Session } from "@app/shared/types";
import { Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { GRAPHQL_QUERY_MY_INTEREST_GROUPS } from "app/queries";
import DocumentContext from "components/DocumentContext";
import PageWrapper from "components/PageWrapper";
import { useFetchDataAndKeepUpdated } from "hooks/useFetchDataAndKeepUpdated";
import _ from "lodash";
import { StringParam, useQueryParams } from "use-query-params";
import { MyInterestGroups } from "../interestGroups/MyInterestGroups";
import { CustomArrayParam, StatusParam } from "./filters/customQueryParamDefinitions";
import { InterestGroupFilter } from "./InterestGroupFilter";
import { InterestGroupList } from "./InterestGroupList";
import { useState } from "react";

const useStyles = makeStyles((theme) => ({}));

export const MemberInterestGroupsPage = () => {
    const classes = useStyles();

    const [groupCount, setGroupCount] = useState(0);

    const [query, setQuery] = useQueryParams({
        topic: CustomArrayParam,
        timeOfDay: CustomArrayParam,
        dayOfWeek: CustomArrayParam,
        status: StatusParam,
        partner: StringParam,
    });

    const { data: myInterestGroupsData, loading: myInterestGroupsLoading } =
        useFetchDataAndKeepUpdated({
            query: GRAPHQL_QUERY_MY_INTEREST_GROUPS,
            pollIntervalInMinutes: 30,
        });
    const myInterestGroupSessions: Session[] | undefined =
        myInterestGroupsData?.myUpcomingInterestGroupSessions;

    let myInterestGroupIds = _.compact(myInterestGroupSessions?.map((x) => x.sangha?.id) || []);

    const resetFilters = () => {
        setQuery({
            topic: undefined,
            timeOfDay: undefined,
            dayOfWeek: undefined,
            status: undefined,
        });
    };

    return (
        <div>
            <DocumentContext title="Mindful Friends" addBrandNameSuffix />

            <PageWrapper data-testid="memberMindfulFriendsPage">
                <Typography variant="h1">Mindful Friends Groups</Typography>
                <MyInterestGroups
                    myInterestGroupSessions={myInterestGroupSessions}
                    loading={myInterestGroupsLoading}
                />

                <Typography variant="h2" id="otherGroupsSection">
                    Other Groups
                </Typography>
                <InterestGroupFilter
                    filters={query}
                    setFilters={setQuery}
                    groupCount={groupCount}
                    resetFilters={resetFilters}
                />
                <InterestGroupList
                    groupIdsToExclude={myInterestGroupIds}
                    filters={query}
                    resetFilters={resetFilters}
                    setGroupCount={setGroupCount}
                />
            </PageWrapper>
        </div>
    );
};
